import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface Props {
  field: Field
  readonly: boolean
  onChange: (value: boolean) => void
}

const AllowEndless = ({ field, onChange, readonly }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-allow-endless-input' }}>
    <Card.Title
      size="small"
      action={<TogglerCheckbox value={!field.value} onChange={onChange} disabled={readonly} />}
    >
      {i18n.t('settings.leave_types.page.duration.form.allow_endless.label')}
    </Card.Title>
  </Card>
)

export default AllowEndless
